<template>
    <v-card>
        <v-toolbar flat dark color="primary">
            <v-toolbar-title>Aggiorna SAL</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form v-model="validForm">
                <v-text-field type="date" v-model="data.date" :rules="rules.date" label="Data SAL" required></v-text-field>
                <v-text-field v-model="data.description" :rules="rules.description" label="Descrizione SAL"></v-text-field>
                <v-slider v-model="data.percent" :rules="rules.percent" :max="100" label="Progresso" class="align-center">
                    <template v-slot:append>
                        <v-text-field v-model="data.percent" :rules="rules.percent" class="mt-0 pt-0" type="number"
                            append-icon="percent"
                            style="width: 80px"></v-text-field>
                    </template>
                </v-slider>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="$emit('close')"><v-icon left>close</v-icon>Annulla</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="save" :disabled="!canSubmit" color="primary"><v-icon left>save</v-icon>Salva</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { Vuelidator, Rule } from '../../Vuelidator/index.js';
import { NormalizeSal } from './ProjectUtils.js';

export default {
    props: {
        value: { type: Object, required: false },
    },
    data() {
        const data = NormalizeSal(this.value);

        const validator = new Vuelidator({
            date: [Rule.required(), Rule.date()],
            description: [Rule.nullable(), Rule.min(1)],
            percent: [Rule.required(), Rule.numeric(), Rule.min(0), Rule.max(100)],
        });
        const rules = validator.getRules();

        return {
            validForm: false,
            data,
            rules,
        }
    },
    computed: {
        canSubmit() {
            return this.validForm;
        },
        isNew() {
            return !this.data.id;
        }
    },
    methods: {
        save() {
            this.$emit('save', this.data);
        }
    },
    watch: {
        value() {
            this.data = NormalizeSal(this.value);
        }
    }
}
</script>